module.exports = __webpack_public_path__ + "static/img/ket-renewal-style-icon-01@m.f5038cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/ket-renewal-style-icon-01@m.png
// module id = MsuB
// module chunks = 0